var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "officialopen" } }, [
    _c(
      "div",
      { staticClass: "open_main", style: "height:" + this.Height + "px" },
      [
        _c("div", { staticClass: "circular" }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.result_show,
                expression: "!result_show",
              },
            ],
            staticClass: "box_info",
          },
          [
            _c("div", { staticClass: "box_title" }, [_vm._v("开箱")]),
            _c("div", { staticClass: "box_name" }, [
              _c("span", [_vm._v("解锁")]),
              _vm._v(_vm._s(_vm.box_data.caseInfo.caseName) + "武器箱"),
            ]),
          ]
        ),
        _c("boxfall", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.animation_status == 0,
              expression: "animation_status == 0",
            },
          ],
          ref: "boxfall",
          attrs: { fall_svga: _vm.drop_svga },
          on: { initial: _vm.initial, finish: _vm.fall_finish },
        }),
        _c("boxmodel", {
          ref: "boxmodel",
          attrs: {
            animation_status: _vm.animation_status,
            box_model: _vm.model_svga,
          },
          on: { initial: _vm.initial, returned: _vm.returned },
        }),
        _c("boxstart", {
          ref: "boxstart",
          attrs: {
            animation_status: _vm.animation_status,
            vague: _vm.start_vague,
            start_svga: _vm.start_svga,
          },
          on: { initial: _vm.initial, finish: _vm.start_finish },
        }),
        _c("conduct", {
          ref: "conduct",
          attrs: {
            goodsList: _vm.box_data.items,
            iSgold: _vm.iSgold,
            suspend_status: _vm.suspend_status,
          },
          on: { move_end: _vm.move_end },
        }),
        _c("result", { ref: "result", on: { setGold: _vm.setGold } }),
        _c("sidebar", { attrs: { animation_status: _vm.animation_status } }),
        _c("contain", {
          attrs: {
            animation_status: _vm.animation_status,
            list: _vm.box_data.items,
          },
          on: { togolden: _vm.togolden },
        }),
        _c("operation", {
          ref: "operation",
          attrs: {
            rootGold: _vm.rootGold,
            box_name: _vm.box_data.caseInfo.caseName,
            price: _vm.box_data.caseInfo.price,
            status: _vm.open_status,
            animation_status: _vm.animation_status,
          },
          on: {
            open_success: _vm.open_success,
            to_stock: _vm.to_stock,
            suspend: _vm.suspend,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }